import React, { useEffect, useMemo, useState } from "react";
import { HiOutlineUser } from "react-icons/hi";
import { useSelector } from "react-redux";
import { getUser } from "store/selector/auth.selector";
import { baseURLImage, classNames } from "Utils/utils";

const isValidProfilePicture = (url) =>
  url && typeof url === "string" && !url.includes("www.pngitem.com");

const SIZE_CLASSES = {
  sm: "h-8 w-8",
  md: "h-9 w-9",
  lg: "h-10 w-10",
};

const ICON_SIZE_CLASSES = {
  sm: "h-3.5 w-3.5",
  md: "h-4 w-4",
  lg: "h-5 w-5",
};

/**
 * Copilot-local user avatar. Pass `className` / `size` for layout-specific styling.
 * @param {{ className?: string, size?: 'sm' | 'md' | 'lg' }} props
 */
const UserAvatar = ({ className = "", size = "md" }) => {
  const currentUser = useSelector(getUser);
  const [imageFailed, setImageFailed] = useState(false);

  const profileSrc = useMemo(() => {
    const picture = currentUser?.profile_picture;
    if (!isValidProfilePicture(picture)) return null;
    return baseURLImage(picture);
  }, [currentUser?.profile_picture]);

  useEffect(() => {
    setImageFailed(false);
  }, [profileSrc]);

  const showImage = Boolean(profileSrc) && !imageFailed;

  return (
    <span
      className={classNames(
        "inline-flex shrink-0 items-center justify-center self-start overflow-hidden rounded-xl bg-[#ECF0FD] text-[#4B6CB7] shadow-md ring-2 ring-white",
        SIZE_CLASSES[size] || SIZE_CLASSES.md,
        className
      )}
    >
      {showImage ? (
        <img
          src={profileSrc}
          alt=""
          className="h-full w-full object-cover"
          onError={() => setImageFailed(true)}
        />
      ) : (
        <HiOutlineUser className={ICON_SIZE_CLASSES[size] || ICON_SIZE_CLASSES.md} />
      )}
    </span>
  );
};

export default UserAvatar;
